import WebApp from '@twa-dev/sdk';

export const telegramLinks = {
  openPhoneCall: (phone: string): void => {
    window.location.href = `tel:${phone}`;
  },

  openTelegramUser: (usernameOrContact: string): void => {
    const username = usernameOrContact.replace(/^@/, '');
    WebApp.openTelegramLink(`https://t.me/${username}`);
  },

  openExternalUrl: (url: string): void => {
    WebApp.openLink(url);
  },

  openMap: (mapUrl: string): void => {
    WebApp.openLink(mapUrl);
  },
};
